import { Routes } from '@angular/router';
import { WrongUrlComponent } from "./wrong-url.component";

export const WrongUrlRoutes: Routes = [
    { path: '', component: WrongUrlComponent, pathMatch: 'full' }
];

